import type * as THREE from 'three';
import type { VehicleDef } from '@typing-racer/shared';

export type StyleId = 'blocky' | 'model';
const KEY = 'typing-racer.style';

export function getStyle(): StyleId {
  try {
    return localStorage.getItem(KEY) === 'model' ? 'model' : 'blocky';
  } catch {
    return 'blocky';
  }
}

export function saveStyle(s: StyleId): void {
  try {
    localStorage.setItem(KEY, s);
  } catch {
    /* ignore */
  }
}

export interface BuiltVehicle {
  root: THREE.Group;
  /** Pivots to spin around their local X axis as the vehicle moves. */
  wheels: THREE.Object3D[];
}

export interface StyleRenderer {
  id: StyleId;
  buildVehicle(def: VehicleDef, colour: string): Promise<BuiltVehicle>;
  buildTree(rng: () => number): Promise<THREE.Object3D>;
  buildBuilding(rng: () => number): Promise<THREE.Object3D>;
  groundMaterial(): THREE.Material;
  roadMaterial(): THREE.Material;
}
